import { render, staticRenderFns } from "./SnackbarMensajes.vue?vue&type=template&id=0f5f41fe&"
import script from "./SnackbarMensajes.vue?vue&type=script&lang=js&"
export * from "./SnackbarMensajes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports